import { ICustomQueryProperty } from "us.collection.admin/interfaces";

export const customQueryProperty: ICustomQueryProperty = {
  sampleQuery: "",
  primaryColumnName: "",
  mandatoryColumns: [],
};
